import './Hero.css';
import { useTranslation } from 'react-i18next';


function Hero() {
  const { t } = useTranslation();
  return (
    <section 
      className="hero-section"
      id="hero"
      style={{
        background: `linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), url(${process.env.PUBLIC_URL}/images/cover.webp)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        overflow: 'hidden'
      }}
    >
      <div className="hero-content">
        <h1>{t('hero.title')}</h1>
        <div className="hero-bar"></div>
        <p className="hero-desc">
          {t('hero.desc')}
        </p>
        <button className="contact-btn" onClick={() => window.location='#contact'}>{t('hero.contact')}</button>
      </div>

    </section>
  );
}

export default Hero; 